import { AxiosError } from 'axios';
import { defineStore } from 'pinia';
import { ref } from 'vue';

import initApi from '@/api/initApiV2';

import { type Partner, PartnersApi, type PartnersApiGetPartnerRequest } from '@/clients/v2';

import { handleApiError } from '@/api/handleApiError.ts';

export const usePartnersStore = defineStore('partners-store', () => {
  const partners = ref<Partner[]>([]);

  const getPartners = async () => {
    try {
      const partnersApi = await initApi(PartnersApi);
      const response = await partnersApi?.getPartners();

      if (!response) return;

      partners.value = response.data;
      return response.data;
    } catch (error) {
      handleApiError(error as AxiosError);
    }
  };

  const getPartner = async (params: PartnersApiGetPartnerRequest) => {
    try {
      const partnersApi = await initApi(PartnersApi);
      const response = await partnersApi?.getPartner(params);

      if (!response) return;

      return response.data;
    } catch (error) {
      handleApiError(error as AxiosError);
    }
  };

  return {
    partners,
    getPartners,
    getPartner,
  };
});
